module.exports = __webpack_public_path__ + "static/media/f5.0389b9a3.png";